module.exports = __webpack_public_path__ + "static/img/product-thumb-adhd.24757a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/design/product-thumb-adhd.png
// module id = hFvH
// module chunks = 13